import { createSlice } from '@reduxjs/toolkit';
import { getBasketData } from 'services/getBasketData';
import { FetchPaymentBasketPayload, PaymentBasketState } from 'types/baskets';
import { getDefaultCompanyId } from 'utils/helpers';
import { getStatus } from 'redux/slices/baskets/givingBasketSilce';
import { createAsyncThunkWrapper } from 'redux/thunk/createAsyncThunkWrapper';

const initialState: PaymentBasketState = {
    activeRecords: [],
    inActiveRecords: [],
    loading: false,
    error: null,
    loadMore: false,
};

export const fetchPaymentBasket = createAsyncThunkWrapper<any, FetchPaymentBasketPayload>(
    'payment/fetchPaymentBasket',
    async ({ status, subType, headers, name }: FetchPaymentBasketPayload, { getState }) => {
        const { pageSize, pageNumber } = headers;
        const state: any = getState();
        const defaultCompanyId = getDefaultCompanyId(state);
        if (!defaultCompanyId) {
            return;
        }
        const res = await getBasketData({ status, subType, companyId: defaultCompanyId, headers, name });
        return { response: res, pageNumber, pageSize, status };
    }
);

const paymentBasketSlice = createSlice({
    name: 'paymentBasket',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchPaymentBasket.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchPaymentBasket.fulfilled, (state, action) => {
            state.loading = false;
            const { payload } = action || {};
            if (!payload) return;

            const { response, pageNumber, pageSize, status } = payload || {};
            const { events } = response || {};
            state.loadMore = events?.length >= pageSize;

            const keyToUpdate = getStatus(status) === 'PENDING' ? 'inActiveRecords' : 'activeRecords';
            state[keyToUpdate] = !pageNumber ? events || [] : [...(state?.[keyToUpdate] || []), ...(events || [])];
        });
        builder.addCase(fetchPaymentBasket.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message || null;
        });
    },
});

export default paymentBasketSlice.reducer;
